import { render } from "./TheGuide.vue?vue&type=template&id=13ae6680&scoped=true"
import script from "./TheGuide.vue?vue&type=script&lang=js"
export * from "./TheGuide.vue?vue&type=script&lang=js"

import "./TheGuide.vue?vue&type=style&index=0&id=13ae6680&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/online-3d-editor-laozicloud3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ae6680"]])

export default __exports__